<template>
  <div class="layout">
    <Aside class="layout_aside" @changeActiveIndex="changeActiveIndex" />
    <div class="layout_main">
      <Tools />
      <Search
        ref="search" v-unshow:[unshowMap.search] :recommendList="recommendList" class="layout_search"
        @search="search" />
      <div class="layout_assort">
        <Drapdown
          :titleC="colorTabByType(homeListType.search)"
          :list="filterList" @select="filterSelect"
          @click.native="clickAll" />
        <div
          v-report:mainclick="{ area: 'user', pos: 0 }"
          :class="['tab', 'tab_collect']" :style="{ color: colorTabByType(homeListType.collect) }"
          @click="clickCollect">已收藏</div>
        <div
          v-report:mainclick="{ area: 'user', pos: 1 }"
          :class="['tab', 'tab_download']" :style="{ color: colorTabByType(homeListType.download) }"
          @click="clickDownload">已下载</div>
        <em v-if="showZoom" :class="['zoom', classZoom]" @click="clickZoom" />
        <Drapdown
          v-show="listType === homeListType.search && classifyList.length" ref="classifyDrapdown" class="layout_level2" :minWidth="100"
          :list="classifyList" @select="classifySelect" />
      </div>
      <div class="layout_mat_list">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Aside from '@/components/Aside/index.vue'
import Tools from '@/components/Tools/index.vue'
import Search from '@/components/Search/index.vue'
import Drapdown from '@/components/Drapdown/index.vue'

import { strictExtend } from '@shared/utils/base/index.js'
import { parseURL } from '@/common/utils.js'

import {
  cat1, cat2, cat3,
  switchKey, WinType,
  winTypeMap, unshowMap, screenType,
  screenTypeDivLine, projectType, homeListType
} from '@/common/const.js'
import { ClientGetOfficeSetting } from '@/api/clientApi.js'
import { report } from '@/report/index.js'
import { isCustomer, isMore, isMidAutumnPack } from '@/common/data.js'
import api from '@/api'
import { openLoginDialogByAbTest } from '@/common/business.js'

const filterList = [
  { name: '全部', value: 1 },
  { name: '最热', value: 2 },
  { name: '最新', value: 3 },
]

const ClassifyItme = { name: '所有分类', id: 0 }

export default {
  name: 'LayoutMain',

  components: { Aside, Tools, Search, Drapdown },

  data () {
    return {
      unshowMap,
      filterList: Object.freeze(filterList),
      classifyList: [],
      homeListType
    }
  },

  computed: {
    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    },

    categoryArr () {
      return this.$store.state.operational.categoryArr
    },

    homeParams () {
      return this.$store.state.home.home
    },

    activeIndex () {
      return this.$store.state.activeIndex
    },

    recommendList () {
      return this.asideArr[this.activeIndex]?.recommendList || []
    },

    listType () {
      return this.$store.state.home.listType
    },

    asideArr () {
      return this.$store.state.home.asideArr
    },

    homeNumberCol () {
      return this.$store.state.home.numberCol
    },

    projectType () {
      return this.$store.state.projectType
    },

    showZoom () {
      return this.projectType === projectType.ppt
    },

    classZoom () {
      return this.homeNumberCol === 1 ? 'to_small' : 'to_big'
    }
  },

  watch: {
    activeIndex () {
      this.setClassifyList()
    }
  },

  created () {
    // 根据url做初始化操作
    this.setActiveAndGetList()
    this.initScreenType()
    this.getWinType()
  },

  methods: {
    /** 点击-全部 **/
    clickAll () {
      this.loadMatListByType(homeListType.search)
    },

    /** 点击-已收藏 **/
    async clickCollect () {
      if (!this.isLoginedIn) {
        openLoginDialogByAbTest(this.$store)
        return
      }

      const hasFavorites = await this.checkHasFavorites()
      if (hasFavorites) {
        this.loadMatListByType(homeListType.collect)
      } else {
        this.$toast({ desc: '您没有已收藏的模板' })
      }
    },

    /** 点击-已下载 **/
    async clickDownload () {
      if (!this.isLoginedIn) {
        openLoginDialogByAbTest(this.$store)
        return
      }

      const hasDownload = await this.checkHasDownload()
      if (hasDownload) {
        this.loadMatListByType(homeListType.download)
      } else {
        this.$toast({ desc: '您没有已下载的模板' })
      }
    },

    colorTabByType (type) {
      if (this.listType === type) {
        return 'rgba(0, 0, 0, 0.8)'
      }
      return 'rgba(0, 0, 0, 0.4)'
    },

    checkHasFavorites () {
      const params = {
        cat1: this.$store.state.home.home[cat1],
        page: 1,
        size: 20
      }
      return api.user.favoriteList({ data: params }).then(res => {
        const list = res?.data?.fav_infos || []
        return list.length > 0
      })
    },

    checkHasDownload () {
      const params = {
        cat1: this.$store.state.home.home[cat1],
        page: 1,
        size: 20
      }
      return api.user.downloads({ data: params }).then(res => {
        const list = res?.data?.download_infos || []
        return list.length > 0
      })
    },

    loadMatListByType (homeListType) {
      this.toTop()
      this.resetHomeList()
      this.$store.commit('home/vuexChangeHomeListType', homeListType)
      this.$store.commit('home/vuexResetHomePage')
      this.$store.dispatch('home/vuexGetMatList')
    },

    resetHomeList () {
      this.$store.commit('home/vuexResetHomeRes')
    },

    clickZoom () {
      const numberColNext = this.homeNumberCol === 1 ? 2 : 1
      this.$store.commit('home/vuexChangeHomeNumberCol', numberColNext)
    },

    initScreenType () {
      const isLowScreen = window.screen.width < screenTypeDivLine
      const type = isLowScreen ? screenType.low : screenType.high
      this.$store.commit('vuexChangScreenType', type)
    },
    getWinType () {
      const urlObj = parseURL(location.href)

      const urlType = winTypeMap[urlObj.params?.[WinType]]
      if (urlType) { // url的wintype必须有且匹配
        this.setWinType(urlType)
      } else {
        ClientGetOfficeSetting(res => {
          const type = res[switchKey.full] ? winTypeMap.mini : winTypeMap.normal
          this.setWinType(type)
        }, () => {
          this.setWinType(winTypeMap.normal)
        })
      }
    },

    setWinType (type) {
      this.changeWinType(type) // 客户端一开始会加载，渲染完了手动触发窗口打开, set窗口类型，类型决定窗口大小
      this.$store.commit('vuexChangeWinTypeDefault', type)
    },

    changeWinType (type) {
      this.$store.dispatch('vuexChangeWinType', type)
    },

    setActiveAndGetList () {
      const urlParams = parseURL(location.href).params

      const obj = {}
      const strKey = ['keyword'] // 接口类型为string的，其他则表示为number

      Object.keys(this.homeParams).forEach(key => {
        if (urlParams[key]) {
          obj[key] = strKey.includes(key) ? urlParams[key] : Number(urlParams[key])
        }
      })
      // 设置查询参数，并获取数据
      this.$store.dispatch('home/vuexChangeHomeParames', obj)

      // 设置左侧导航栏的下标
      this.setActiveIndex()
    },

    setActiveIndex () {
      const list = strictExtend(this.asideArr)

      // 匹配侧边栏数据符合的一个，倒序因为导航栏非标准分类
      const indexItem = list.filter(item => !item[isMore] && !item[isCustomer] && !item[isMidAutumnPack]).reverse().find(item => {
        return [cat1, cat2, cat3].every(key => {
          return !item[key] || this.homeParams[key] === item[key]
        })
      })

      if (this.activeIndex === indexItem.activeIndex) { // 如果activeIndex相等，就得手动触发watch的方法
        this.setClassifyList()
        return
      }

      this.$store.commit('vuexChangeActiveIndex', indexItem.activeIndex)
    },

    setClassifyList (obj) {
      const params = obj || this.homeParams
      const arr = this.getCategoryItem([params[cat1], params[cat2], params[cat3]])

      // 左侧的分类中，有一级、二级，二级分类都是一级分类下面的，右侧的下拉需要过滤
      const asideIds = this.asideArr.map(item => item.cat2)
      const lastArr = arr.filter(item => !asideIds.includes(item.id))

      this.classifyList = [ClassifyItme, ...lastArr]
    },

    getCategoryItem (idArr) {
      let arr = this.categoryArr

      idArr.forEach(id => {
        arr = (arr.find(item => item.id === id)?.list || arr)
      })

      return arr
    },

    toTop () {
      this.$emit('toTop')
    },

    vuexChangeHomeParames (obj) {
      this.toTop()
      this.$store.dispatch('home/vuexChangeHomeParames', obj)
    },

    search (keyword) {
      this.resetHomeList()
      this.$store.dispatch('home/vuexResetClassify', { keyword })

      this.$refs.classifyDrapdown.reset() // 重置为第一个选项
      this.toTop()
    },

    resetListState () {
      this.toTop()
      this.$store.commit('home/vuexResetHomeRes')
    },

    changeActiveIndex (index) {
      this.changeWinType(winTypeMap.normal)

      if (index === this.activeIndex) { return }

      this.$store.commit('home/vuexChangeHomeListType', homeListType.search)

      this.resetListState()
      this.$refs.search && this.$refs.search.clearVal() // 不同分类的素材，相距过大，所以，搜索词基本无用
      this.$store.dispatch('home/vuexChangeActiveIndex', index) // 会清空keyword接口字段
    },

    filterSelect ({ item, index }) {
      report('mainclick', { area: 'sort', pos: index })

      this.resetListState()
      this.vuexChangeHomeParames({ sort: item.value })
    },

    classifySelect ({ item }) {
      report('mainclick', { area: 'classify', pos: '' })

      this.resetListState()

      if (item.id === ClassifyItme.id) { // 选择全部分类
        this.$store.dispatch('home/vuexResetActiveIndex')
        return
      }

      const treecode = item.treecode
      if (!treecode) { return } // 因为不知道是几级分类，所以得把所有分类全部重置

      const obj = {}
      treecode.split('-').forEach((id, idx) => {
        obj[`cat${idx + 1}`] = Number(id)
      })

      // 重置搜索内容
      obj.keyword = ''
      this.$refs.search && this.$refs.search.clearVal() // 重置为第一个选项

      this.vuexChangeHomeParames(obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout { position: relative; display: flex; height: 100%;
  .layout_main { position: relative; box-sizing: border-box; display: flex; flex: 1; flex-direction: column; width: 100%; height: 100%; padding-bottom: 5px; overflow: hidden;
    .layout_search { border-bottom: 1px solid $border_color; }
    .layout_assort { display: flex; align-items: center; height: 55px; background-color: #fff; border-bottom: 1px solid $border_color;
      .zoom { display: block; width: 20px; height: 20px; margin-right: 20px; margin-left: auto; cursor: pointer; background-repeat: no-repeat; background-position: center; background-size: cover;
        &.to_small { background-image: url(~@/assets/images/icon_to_small.svg); }
        &.to_small:hover { background-image: url(~@/assets/images/icon_to_small_hover.svg); }
        &.to_big { background-image: url(~@/assets/images/icon_to_big.svg); }
        &.to_big:hover { background-image: url(~@/assets/images/icon_to_big_hover.svg); }
      }
      .tab { font-size: 16px; font-weight: 400; color: $font_color_8; cursor: pointer;
        &.tab_download { margin-right: auto; margin-left: 10px; }
      }
    }
    .layout_level2 { float: right; margin-right: 10px; }
    .layout_mat_list { flex: 1; overflow: hidden; font-size: 0; }
  }
}
</style>
